import type { CargoItemRes } from 'api/swagger';

export interface CargoItemGroup
  extends Omit<CargoItemRes, 'id' | 'compositeId' | 'cargoId' | 'orderId' | 'createdAt' | 'updatedAt' | 'deletedAt'> {
  count: number;
}

// не используется
export const groupCargosBySize = (cargos: CargoItemRes[]): CargoItemGroup[] => {
  const groups = new Map<string, CargoItemGroup>();

  cargos.forEach((cargo) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { id, compositeId, cargoId, orderId, createdAt, updatedAt, deletedAt, ...sizeInfo } = cargo;
    const compareStr = `${cargo.length}/${cargo.width}/${cargo.height}/${cargo.weight || 0}/${cargo.stack}`;
    if (groups.has(compareStr)) {
      const currentGroup = groups.get(compareStr) as CargoItemGroup;
      groups.set(compareStr, { ...currentGroup, count: currentGroup.count + 1 });
    } else {
      groups.set(compareStr, { ...sizeInfo, count: 1 });
    }
  });

  return Array.from(groups, (group) => group[1]);
};
